module.exports = "https://cdn.realtymogul.com/static/media/social_youtube_gray.72d54b42.svg";